/**
 * This component is bagging to be refactore as it returns null twice and the logic is overcomplicated
 */
import type { FC, ReactNode } from "react";

import type { FormTarget, OrderAttribute } from "@jti/magento";
import { IOrderInputTypeEnum } from "@jti/magento";
import { useGetProfile } from "@jti/rest-api";
import { useSelector } from "@jti/store/reduxHooks";
import { selectOrderAttributesByTarget } from "@jti/store/selectors/selectOrderAttributesByTarget";

import { OrderAttributeCheckbox } from "./OrderAttributeCheckbox";
import { OrderAttributeTextInput } from "./OrderAttributeTextInput";

type OrderAttributesProps = {
  target: FormTarget;
};

type RenderInput = (props: { orderAttribute: OrderAttribute; key: string }) => ReactNode;

const componentsMap = new Map<string, RenderInput>(
  Object.entries({
    [IOrderInputTypeEnum.Text]: (props) => <OrderAttributeTextInput {...props} />,
    [IOrderInputTypeEnum.Checkbox]: (props) => <OrderAttributeCheckbox {...props} />,
  })
);

export const OrderAttributes: FC<OrderAttributesProps> = ({ target }) => {
  const getUserProfileQuery = useGetProfile();

  const orderAttributes = useSelector((state) => selectOrderAttributesByTarget(state, target));

  if (getUserProfileQuery.isLoading) {
    return null;
  }

  return (
    <>
      {orderAttributes.map((orderAttribute: OrderAttribute) => {
        if (getUserProfileQuery.data?.extra && !!getUserProfileQuery.data.extra[orderAttribute.code]) {
          return null;
        }

        return componentsMap.get(orderAttribute.input_type)?.({ orderAttribute, key: orderAttribute.code });
      })}
    </>
  );
};
